import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { CompanyCollectorGroupService } from '@core/services/entities/company-collector-group.service';
import { CompanyCollectorGroupResponseDto } from '@domain/company-collector-group/dtos/company-collector-group-response.dto';
import { CreateCompanyCollectorGroupRequestDto } from '@domain/company-collector-group/dtos/create-company-collector-group-request.dto';
import { ListCompanyCollectorGroupRequestDto } from '@domain/company-collector-group/dtos/list-company-collector-group.dto-request';
import { UpdateCompanyCollectorGroupMerchantsRequestDto } from '@domain/company-collector-group/dtos/update-company-collector-group-merchants-request.dto';
import { UpdateCompanyCollectorGroupRequestDto } from '@domain/company-collector-group/dtos/update-company-collector-group-request.dto';
import { CompanyCollectorGroupRepository } from '@domain/company-collector-group/repositories/company-collector-group.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompanyCollectorGroupRepositoryService
  implements CompanyCollectorGroupRepository
{
  constructor(
    private companyCollectorGroupService: CompanyCollectorGroupService,
  ) {}

  list(
    request: ListCompanyCollectorGroupRequestDto,
  ): Observable<
    ApiResponse<PageableResponse<CompanyCollectorGroupResponseDto>>
  > {
    return this.companyCollectorGroupService.list(request);
  }

  create(
    request: CreateCompanyCollectorGroupRequestDto,
  ): Observable<ApiResponse<CompanyCollectorGroupResponseDto>> {
    return this.companyCollectorGroupService.create(request);
  }

  update(
    request: UpdateCompanyCollectorGroupRequestDto,
  ): Observable<ApiResponse<CompanyCollectorGroupResponseDto>> {
    return this.companyCollectorGroupService.update(request);
  }

  updateMerchants(
    request: UpdateCompanyCollectorGroupMerchantsRequestDto,
  ): Observable<ApiResponse<CompanyCollectorGroupResponseDto>> {
    return this.companyCollectorGroupService.updateMerchants(request);
  }

  delete(
    request: RefId,
  ): Observable<ApiResponse<CompanyCollectorGroupResponseDto>> {
    return this.companyCollectorGroupService.delete(request);
  }
}
